// extracted by mini-css-extract-plugin
export var chevron = "_j8-4";
export var chevronExpanded = "_j8-5";
export var row = "_j8-0";
export var rowBody = "_j8-6";
export var rowDescription = "_j8-7";
export var rowHeader = "_j8-1";
export var rowTitle = "_j8-2";
export var rowTitleComplete = "_j8-3";